import { alertConstants } from '../_constants';

export const alertActions = {
  success,
  error,
  clear,
  notification,
  sync,
  offline,
};

function success(message) {
  return { type: alertConstants.SUCCESS, message };
}

function error(message) {
  return { type: alertConstants.ERROR, message };
}

function clear() {
  return { type: alertConstants.CLEAR };
}

function notification(message, autohide = true) {
  return { type: alertConstants.NOTIFICATION, message, autohide };
}

function sync(message) {
  return { type: alertConstants.SYNC, message };
}

function offline(message) {
  return { type: alertConstants.OFFLINE, message };
}
